import { Type } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsIn,
  ValidateNested,
} from 'class-validator';
import {
  ANONYMOUS_ANALYTICS_EVENT_NAMES,
  type AnalyticsEventName,
} from './analytics-catalogue';
import {
  AnalyticsBatchFieldsDto,
  AnalyticsEventDto,
  AnalyticsEventFieldsDto,
} from './analytics-event.dto';

export const MAX_ANALYTICS_EVENTS_PER_BATCH = 20;

export const ANALYTICS_ROUTES = {
  controller: 'analytics',
  signedIn: 'events',
  anonymous: 'anonymous-events',
} as const;

export class TrackAnonymousAnalyticsEventDto extends AnalyticsEventFieldsDto {
  @IsIn(ANONYMOUS_ANALYTICS_EVENT_NAMES)
  name: AnalyticsEventName;
}

const BatchEvents =
  (eventType: new () => AnalyticsEventFieldsDto): PropertyDecorator =>
  (target, key) =>
    [
      IsArray(),
      ArrayMinSize(1),
      ArrayMaxSize(MAX_ANALYTICS_EVENTS_PER_BATCH),
      ValidateNested({ each: true }),
      Type(() => eventType),
    ].forEach((decorate) => decorate(target, key));

export class TrackAnalyticsEventsDto extends AnalyticsBatchFieldsDto {
  @BatchEvents(AnalyticsEventDto)
  events: AnalyticsEventDto[];
}

export class TrackAnonymousAnalyticsEventsDto extends AnalyticsBatchFieldsDto {
  @BatchEvents(TrackAnonymousAnalyticsEventDto)
  events: TrackAnonymousAnalyticsEventDto[];
}
